module.exports = __webpack_public_path__ + "static/img/descBg.230d49b5.png";